import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/allocation/styles.scss';export default {
  "allocation": "_allocation_1m19p_1",
  "removeAllocation": "_removeAllocation_1m19p_11",
  "resource": "_resource_1m19p_15",
  "container": "_container_1m19p_23",
  "label": "_label_1m19p_30",
  "center": "_center_1m19p_36",
  "avatar": "_avatar_1m19p_40",
  "user": "_user_1m19p_47",
  "name": "_name_1m19p_54",
  "title": "_title_1m19p_60",
  "allocatedHours": "_allocatedHours_1m19p_65",
  "completionCheck": "_completionCheck_1m19p_82",
  "binIcon": "_binIcon_1m19p_90"
};